import PropTypes from 'prop-types';
import { useState, useEffect, useCallback} from 'react';
// @mui
import { useSelector } from 'react-redux';
import {Button, Dialog, DialogTitle, DialogActions, DialogContent, Table, TableBody, TableContainer, TextField, InputAdornment} from '@mui/material';
import {useTable, TableHeadCustom, TablePaginationCustom} from '../../../../components/table/index.js';
import FindTableRow from './find-table-row.js';
import { useMutation, useQuery } from "@apollo/react-hooks";
import { GET_ALL_USERS } from "../../../../graphql/modules/users.js";
import Iconify from 'src/components/iconify/iconify';
// ----------------------------------------------------------------------
const TABLE_HEAD = [
  {id: 'fullName', label: 'Trainer/Assessor'}
]

export default function FindDialog({ title, action, open, onClose, setFullName, ...other }) {
   const table = useTable();
     const [results, setResults] = useState(null);
    const company = useSelector((state) => state?.auth?.company);
     const [searchText, setSearch] = useState("");

     const { data, loading, error, refetch } = useQuery(  GET_ALL_USERS, {
       variables: {
         limit: table?.rowsPerPage,
         offset: table?.page,
         companyName: company,
         searchText: searchText,
         filter: "ta",
        order: table.order || 'asc',
         orderBy: table.orderBy || 'fullname',
         },
         fetchPolicy: "cache-and-network",
       });
   
       useEffect(() => {
         if(data){
           setResults(data?.getUsers)
         }
     }, [data, searchText])

      const handleFilters = useCallback((value) => {
           setSearch(value)
         },
         [table]
       );

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>
         <DialogContent sx={{ typography: 'body2' }}>
                      <TextField
                    fullWidth
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => handleFilters(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" sx={{color: 'text.disabled'}} />
                            </InputAdornment>
                        )
                    }}
                    sx={{mb: 1}}
                    />

                      <TableContainer sx={{ position: 'relative', overflow: 'unset'}}>
                          <Table>
                            
                          <TableHeadCustom
                            headLabel={TABLE_HEAD}
                            order={table.order}
                            orderBy={table.orderBy}
                            onSort={table.onSort}
                          />
                             {results?.results?.map((row) => (
                                                <FindTableRow
                                                key={row?.id}
                                                row={row}
                                                onSelectRow={() => setFullName(row)}
                                                onClose={onClose}
                                                // onViewRow={() => handleViewAccount(row)}
                                                // onDeleteRow={() => handleDeleteRow(row._id)}
                                                // onEditRow={() => handleEditRow(row)}
                                              />
                             ))}
            
               
                            <TableBody></TableBody>
            
                          </Table>
                      </TableContainer>
         </DialogContent>

      <DialogActions>
        {action}
      </DialogActions>
    </Dialog>
  );
}

FindDialog.propTypes = {
  action: PropTypes.node,
  content: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
};
